// extracted by mini-css-extract-plugin
export default {"root":"FranchiseeDetails_root__y9SfJ","container":"FranchiseeDetails_container__CSE8J","btn-location":"FranchiseeDetails_btn-location__Cxp1O"};